<!--
  组件说明：分类组件，根据type类型，分别生成：考试分类、试卷分类、试题分类
  调用示范：
  <classify :value.sync="fldh" :type="exam"></classify>
-->
<template>
  <el-select v-model="flbh" :multiple="multiple"
    :collapse-tags="multiple" filterable :placeholder="placeholder" @change="change"
    :size="size"
  >
    <el-option
      v-for="item in data"
      :key="item.flbh"
      :label="item.flmc"
      :value="item.flbh">
    </el-option>
  </el-select>
</template>
<script>
import { getClassifyList as examClassify } from '@/api/exam'
import { getClassifyList as examPaperClassify } from '@/api/examPaper'
import { getClassifyList as questionsClassify } from '@/api/questions'

export default {
  data () {
    return {
      data: [],
      placeholder: '',
      flbh: this.value
    }
  },
  props: {
    type: String,
    value: [Number, Array],
    multiple: {
      type: Boolean,
      default: () => { return false }
    },
    size: {
      type: String,
      default: () => { return 'small' }
    }
  },
  watch: {
    value (val) {
      this.flbh = val
    }
  },
  methods: {
    change () {
      this.$emit('update:value', this.flbh)
    },
    // 将数据转成成树形结构
    parseTree (list) {
      const temp = {}
      const tree = {}
      // 数组转 键值对
      list.forEach(obj => {
        temp[obj.flbh] = obj
      })
      for (const flbh in temp) {
        const obj = temp[flbh]
        const sjObj = temp[obj.sjfl]
        if (sjObj) {
          if (!sjObj.children) {
            sjObj.children = []
          }
          sjObj.children.push(obj)
        } else {
          tree[flbh] = obj
        }
      }
      const level = 0
      const rootNodeList = Object.keys(tree).map(key => tree[key])
      this.parseTree2(rootNodeList, level)
    },
    parseTree2 (nodeList, level) {
      level = level + 1
      for (const idx in nodeList) {
        const node = nodeList[idx]
        for (let a = 1; a < level; a++) {
          node.flmc = '　' + node.flmc
        }
        this.data.push(node)
        if (node.children) {
          this.parseTree2(node.children, level)
        }
      }
    }
  },
  created () {
    const type = this.type
    let classify
    switch (type) {
      case 'exam':
        classify = examClassify
        this.placeholder = '请选择考试分类'
        break
      case 'examPaper':
        classify = examPaperClassify
        this.placeholder = '请选择试卷分类'
        break
      case 'questions':
        classify = questionsClassify
        this.placeholder = '请选择试题分类'
        break
      default:
        this.data = []
    }
    if (classify) {
      classify(null).then(res => {
        this.$http.callback(res, () => {
          this.data.splice(0, this.data.length)
          this.parseTree(res.data)
        })
      })
    }
  }
}
</script>
